export default __webpack_public_path__ + "677e29f09b665e6d784aa40ac4250072.png";